export default __webpack_public_path__ + "static/plywood-51210f427465d2618046e01bb8076c10.png";